// src/data/countryCodes.js
const countryCodes = [
  // Afrique de l'Ouest
  { code: "+225", name: "Côte d'Ivoire", label: "Côte d'Ivoire", flag: "🇨🇮", countryCode: "CI" },
  { code: "+221", name: "Sénégal", label: "Sénégal", flag: "🇸🇳", countryCode: "SN" },
  { code: "+229", name: "Bénin", label: "Bénin", flag: "🇧🇯", countryCode: "BJ" },
  { code: "+226", name: "Burkina Faso", label: "Burkina Faso", flag: "🇧🇫", countryCode: "BF" },
  { code: "+228", name: "Togo", label: "Togo", flag: "🇹🇬", countryCode: "TG" },
  { code: "+234", name: "Nigeria", label: "Nigeria", flag: "🇳🇬", countryCode: "NG" },
  { code: "+233", name: "Ghana", label: "Ghana", flag: "🇬🇭", countryCode: "GH" },
  { code: "+223", name: "Mali", label: "Mali", flag: "🇲🇱", countryCode: "ML" },
  { code: "+227", name: "Niger", label: "Niger", flag: "🇳🇪", countryCode: "NE" },
  { code: "+224", name: "Guinée", label: "Guinée", flag: "🇬🇳", countryCode: "GN" },
  { code: "+245", name: "Guinée-Bissau", label: "Guinée-Bissau", flag: "🇬🇼", countryCode: "GW" },
  { code: "+235", name: "Tchad", label: "Tchad", flag: "🇹🇩", countryCode: "TD" },
  { code: "+231", name: "Libéria", label: "Libéria", flag: "🇱🇷", countryCode: "LR" },
  { code: "+232", name: "Sierra Leone", label: "Sierra Leone", flag: "🇸🇱", countryCode: "SL" },
  { code: "+238", name: "Cap-Vert", label: "Cap-Vert", flag: "🇨🇻", countryCode: "CV" },
  { code: "+222", name: "Mauritanie", label: "Mauritanie", flag: "🇲🇷", countryCode: "MR" },
  { code: "+220", name: "Gambie", label: "Gambie", flag: "🇬🇲", countryCode: "GM" },
  { code: "+236", name: "République centrafricaine", label: "République centrafricaine", flag: "🇨🇫", countryCode: "CF" },
  
];

// Fonction pour trouver un indicatif par code pays
export const getCountryByCode = (countryCode) => {
  return countryCodes.find(country => country.countryCode === countryCode) || countryCodes[0];
};

// Fonction pour trouver un indicatif par numéro de code
export const getCountryByPhoneCode = (phoneCode) => {
  return countryCodes.find(country => country.code === phoneCode) || countryCodes[0];
};

export default countryCodes;